import { faChevronUp, faChevronDown } from "@jewlr/pro-regular-svg-icons"
import { Box, FontAwesomeIcon, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState } from "react"

import { jewlr_t } from "helpers/application"

import {
  PlanTitle,
  PlanDesc,
  Container,
  PlanGirlImage,
  PlanImage,
} from "./component"
import KlarnaDetail from "./klarna-detail"

const Klarna = ({ paymentPrices }) => {
  const [hideDetail, setHideDetail] = useState(true)

  return (
    <Container pb={{ _: 4, desktop: 8 }}>
      <Box maxWidth={{ desktop: "344px" }} mx="auto">
        <PlanTitle letterSpacing="-1.4px">Shop Now, Pay Over Time</PlanTitle>

        <PlanImage
          alt="Jewlr Klarna"
          ratio="282 / 117"
          srcSet={`${require("images/info/payment_plans/klarna-jewlr-payments.png")} 282w, ${require("images/info/payment_plans/klarna-jewlr-payments-2x.png")} 562w`}
        />

        <PlanDesc width={{ desktop: "312px" }}>
          Get the {jewlr_t("jewelry")} you love now and pay over time with your
          choice of flexible monthly financing or four payments.
        </PlanDesc>
        <PlanGirlImage
          alt="klarna girl"
          src={require("images/info/payment_plans/klarna-girl-x2.jpg")}
        />

        <MediaBox
          color="link"
          lessThan="desktop"
          onClick={() => setHideDetail(!hideDetail)}
          pb={hideDetail ? 0 : "22px"}
        >
          <span style={{ textDecoration: "underline" }}>How it works</span>
          <FontAwesomeIcon
            color="link"
            icon={hideDetail ? faChevronDown : faChevronUp}
            style={{ marginLeft: "4px", verticalAlign: "sub" }}
          />
        </MediaBox>
        <MediaBox {...(!hideDetail && { lessThan: "desktop" })}>
          <KlarnaDetail paymentPrices={paymentPrices} />
        </MediaBox>
      </Box>
    </Container>
  )
}

Klarna.propTypes = {
  paymentPrices: PropTypes.object,
}

export default Klarna
